<template>
  <v-row no-gutters>
    <v-col :cols="8">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle>{{ title }}</v-list-item-subtitle>
          <v-list-item-title v-if="newValue && !isObjectEmpty(newValue)">{{ newValue[contentTypeField] }}</v-list-item-title>
          <v-list-item-title v-else>--</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="4" align-self="center" class="d-flex justify-center">
      <SingleTablePopUp
        v-model="newValue"
        :single-select="true"
        direction="left"
        :list="availablesContentType"
        :icon="icon"
        :field="contentTypeField"
        width="450"
      />
    </v-col>
  </v-row>
</template>

<script>
import { ref, watch } from '@vue/composition-api';
import SingleTablePopUp from '../../SingleTablePopUp.vue';
import { isObjectEmpty } from '../../../helpers/utils';

export default {
  components: { SingleTablePopUp },
  props: {
    value: {
      type: Object,
      default () {
        return {};
      }
    },
    title: {
      type: String,
      default: null
    },
    contentTypeField: {
      type: String,
      default: null
    },
    availablesContentType: {
      type: Array,
      default () {
        return [];
      }
    },
    updateSession: {
      type: Function,
      default: null
    },
    icon: {
      type: String,
      default: null
    }
  },
  setup (props, context) {
    const newValue = ref(props.value);

    // v-model
    watch(newValue, () => {
      context.emit('input', newValue.value);
      props.updateSession();
    });

    watch(() => props.value, () => {
      newValue.value = props.value;
    });

    return { isObjectEmpty, newValue };
  }
};
</script>
